<template>
  <main id="js-page-content" role="main" class="page-content">
    <div class="row">
      <div class="subheader col-6">
        <h1 class="subheader-title">確定ＡＢＣリスト</h1>
      </div>
      <!-- Right content on content header A nice area to add graphs or buttons -->
      <div class="subheader-block ml-auto demo">
        <button
          type="button"
          :disabled="btnDisable"
          class="btn btn-primary waves-effect waves-themed"
        >
          <span class="fal fa-download mr-1"></span>作成
        </button>
      </div>
    </div>
    <!-- Your main content goes below here: -->
    <div class="row">
      <div class="col-xl-12">
        <div id="panel-1" class="panel">
          <div class="panel-hdr">
            <h2>対象</h2>
            <div class="panel-toolbar">
              <button
                class="btn btn-panel"
                data-action="panel-collapse"
                data-toggle="tooltip"
                data-offset="0,10"
                data-original-title="Collapse"
              ></button>
              <button
                class="btn btn-panel"
                data-action="panel-fullscreen"
                data-toggle="tooltip"
                data-offset="0,10"
                data-original-title="Fullscreen"
              ></button>
            </div>
          </div>
          <div class="panel-container show" id="panel-target">
            <div class="loader">
              <i class="fal fa-spinner-third fa-spin-4x fs-xxl"></i>
            </div>
            <div
              class="panel-content border-faded border-left-0 border-right-0 border-top-0 d-flex"
            >
              <div class="row">
                <div class="col-auto mr-auto">
                  <div class="custom-control custom-checkbox">
                    <input
                      type="checkbox"
                      id="ckCheck"
                      class="custom-control-input"
                    />
                    <label class="custom-control-label" for="ckCheck"
                      >見込みを含む</label
                    >
                  </div>
                </div>
              </div>
            </div>
            <div class="panel-content contents">
              <div class="row">
                <div class="col-md-1 contTitle">出力年度</div>
                <div class="col-md-5 contCnt">
                  <vSelect :options="optionsOp"></vSelect>
                </div>
                <div class="col-md-1 contTitle">拠点</div>
                <div class="col-md-5 contCnt">
                  <vSelect :options="optionsOp2"></vSelect>
                </div>
              </div>
              <div class="row">
                <div class="col-md-1 contTitle">月</div>
                <div class="col-md-5 contCnt">
                  <vSelect :options="optionsOp3"></vSelect>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- エラー確認モーダル -->
    <!-- エラー確認モーダル -->
  </main>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import Mo_modal_alert from "@/components/molecules/Mo_modal_alert.vue";

@Options({
  components: {
    vSelect,
    Mo_modal_alert,
  },
})
export default class FinalABCList extends Vue {
  //----------------------
  //DOM連携用プロパティ
  //----------------------
  btnDisable = false;
  domCover = false;
  domYear = { label: "" };
  domMonth = { label: "" };

  optionsOp = [
    { label: "59" },
    { label: "60" },
    { label: "61" },
    { label: "62" },
  ];
  optionsOp2 = [
    { label: "1" },
    { label: "2" },
    { label: "3" },
    { label: "4" },
    { label: "5" },
  ];
  optionsOp3 = [
    { label: "すべて" },
    { label: "1" },
    { label: "2" },
    { label: "3" },
    { label: "4" },
    { label: "5" },
    { label: "6" },
    { label: "7" },
    { label: "8" },
    { label: "9" },
    { label: "10" },
    { label: "11" },
    { label: "12" },
  ];
}
</script>
